import React from 'react';
import PropTypes from 'prop-types';
import StateSelect from './stateSelect';

class Address extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'Address';
        this.state = {
        	address_country : "United States"
        }

        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(change) {
    	if(this.props.onChange)
			this.props.onChange(Object.assign({}, this.props.address, change));
    }
    componentDidMount() {
    }
    render() {
        return (
    	<div className="row">
	        <div className="col-xs-12 col-md-">
		        <div className="control-label">Address</div>
		        <input type="text" className="form-control mb-sm" onChange={ ({target}) => this.handleChange({address_line1 : target.value }) } name="address.street" value={this.props.address.address_line1} placeholder="Street" />
		    </div>
	        <div className="col-xs-12">
		        <div className="control-label">City</div>
		        <input type="text" className="form-control mb-sm" onChange={ ({target}) => this.handleChange({ address_city : target.value }) } name="address.city" value={this.props.address.address_city} placeholder="City" />
		    </div>
	        <div className="col-xs-12 col-md-8">
		        <div className="control-label">State</div>
		        <StateSelect onChange={(event)=> {

                    this.handleChange({address_state : event.target.value}) } } name="address.state" value={this.props.address.address_state} className="form-control mb-sm" />
		    </div>
	        <div className="col-xs-12 col-md-4">
		        <div className="control-label">Zip</div>
		        <input type="text" className="form-control mb-sm" onChange={ ({target}) => this.handleChange({address_zip : target.value }) } name="address.zip" value={this.props.address.address_zip} placeholder="Zip" />
		    </div>
        </div>
        );
    }
}



export default Address;



// WEBPACK FOOTER //
// ./src/browser/components/forms/address.js